import Component from '../../ui-components/Component';
import React from 'react';
import {path} from '../../utils';
import styles from './styles';
import { withResizer, withTranslations } from '../../HoCs';
import Avatar from '@material-ui/core/Avatar';
import {OYO_WHITE} from '../../Images';
import {highlight} from '../../resources/styles';
import ButtonBase from '@material-ui/core/ButtonBase';

class NotFoundScreen extends Component {
    
    styles=styles;
    translation_key = 'master_franchise_translations';
    state = {
        data:{}
    };
    
    componentDidMount() {
        this.setState({data:path(window.__SERVER_DATA__,'auxillary_data',{})});
    }
    
    renderMF = (data) => {
        const metadata = path(data,'metadata',{});
        const {email,full_name} = data;
        const {mf_address, cluster, city, mf_contact, mf_image_url, mf_description,mf_joining_date} = metadata;
        const mobileVSmall = this.props.resizeData.width < 400;
        return <>
            <div style={this.gs('mf_container')}>
                <div style={this.gs('mf_head')}>
                    <img src={OYO_WHITE} style={this.gs('oyo_white')}/>
                    <div style={{...this.gs('sathi_text'),...(mobileVSmall?{fontSize:14}:{})}}>
                        { this.gc('the_worlds_fastest') }
                    </div>
                </div>
                <div style={this.gs('mf_body')}>
                    <div style={this.gs('profile')}>
                        <Avatar
                            style={this.gs('avatar')}
                            children={'Profile Picture'}
                            src={mf_image_url}/>
                        <div style={this.gs('profile_box')}>
                    
                            <b>{full_name}</b><br/><br/>
                            { this.gc('oyo_saathi') }<br/>
                            {this.props.translationsData.country_iso_code != 'us' && <>{cluster}<br/></>}
                            {city}<br/>
                            {this.props.translationsData.country_iso_code == 'us' && <>USA<br/></>}
                            <br/>
                            { this.gc('saathi_since') }{' '}{mf_joining_date}
                
                
                        </div>
                    </div>
                    <div style={this.gs('description')}>
                
                        <div style={this.gs('description_top_box')}>
                            <div style={this.gs('contact_info_box')}>
                        
                                <b>{ this.gc('contact_info') }</b><br/>
                                <br/>
                                <a href={'mailto: '+email} style={highlight}>{email}</a><br/>
                                <a href={'tel: '+mf_contact}>{mf_contact}</a><br/>
                    
                            </div>
                            <div style={this.gs('address_box')}>
                        
                                <b>{ this.gc('Address') }</b><br/>
                                <br/>
                                {mf_address}
                    
                            </div>
                        </div>
                        <div style={this.gs('description_text_box')}>
                            <b>{ this.gc('About') }{' '}{full_name}</b><br/>
                            <br/>
                            {mf_description}
                        </div>
    
                        <div style={this.gs('bottom_btns_container')}>
                            
                            
    
                            <a target="_blank"
                               href={this.gc('contact_oyo_saathi_link')}>
                            <ButtonBase style={this.gs('contact_box')}>
                                <b>{ this.gc('Contact') }{' '}{full_name}</b>
                            </ButtonBase>
                            </a>
                            
                            {mobileVSmall && <br/>}
    
                            <a target="_blank"
                               href={this.gc('become_oyo_saathi_link')}>
                                <ButtonBase style={{...this.gs('become_oyo_sathi_box'),...(mobileVSmall?{marginLeft:0}:{})}}>
                                    <b>{ this.gc('become_an_oyo_saathi') }</b>
                                </ButtonBase>
                            </a>
                            
                        </div>
                        
                        
            
                    </div>
                </div>
            </div>
        </>
    };
    
    render() {
        return (
            this.renderMF(path(window.__SERVER_DATA__,'auxillary_data',{}))
        );
    }
}

export default withTranslations(withResizer(NotFoundScreen));